module.exports = __webpack_public_path__ + "media/images/company_message_photo-7e4aee38b72533891d1d661fe12e7a59.png";